import type {
  IOnboardingRequestBrokerageSetupApprovalBody,
  IOnboardingRequestBrokerageSetupApprovalResponse,
} from '@/app-package';

import axios from 'axios';

const requestBrokerageSetupApproval = async (
  body: IOnboardingRequestBrokerageSetupApprovalBody,
  orgClaimHash: string,
) => {
  const url = `/onboarding/brokerage_setup/request_approval/${orgClaimHash}`;

  await axios.post<IOnboardingRequestBrokerageSetupApprovalResponse>(url, body);
};

export default requestBrokerageSetupApproval;
